import React, { useEffect, useState, memo } from 'react';
import axios from 'axios';
import FlipNumbers from 'react-flip-numbers';
import { Card } from 'react-bootstrap';
import { useAppContext } from '../../providers/AppProvider.js';
import { FallingLines } from 'react-loader-spinner';
import { isLiveTimeRange } from '../charts/utils/chartUtils';
import { INFLUX_API } from '../../config/api';

const TotalColorYield = ({ bucket, startTime, endTime }) => {
  const [colorYield, setColorYield] = useState(0);
  const [loading, setLoading] = useState(true);

  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  // Function to fetch data
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${INFLUX_API}/api/influx/l75/total-color-yield?start=${startTime}&end=${endTime}&bucket=${bucket}`
      );

      if (response.data.length > 0) {
        setColorYield(response.data[0].yield.toFixed(2));
      }
    } catch (error) {
      console.error('Error fetching Color Yield data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const intervalId = isLiveTimeRange(endTime) ? setInterval(fetchData, 90000) : null; // Fetch every 1.5 minutes
    return () => clearInterval(intervalId);
  }, [bucket, startTime, endTime]);

  if (loading) {
    return (
      <Card className="h-100">
        <Card.Body style={styles.cardBody}>
          <div style={styles.spinnerContainer}>
            <FallingLines
              color={theme === 'dark' ? 'white' : '#3874ff'}
              width="100"
              visible={true}
              ariaLabel="loading-indicator"
            />
          </div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column align-items-center justify-content-center">
        <h5 style={{ color: getThemeColor('dark'), fontWeight: 'bold' }}>
          Total Color Yield (kg)
        </h5>
        <FlipNumbers
          height={50}
          width={50}
          color={'#3874ff'}
          background="none"
          play
          perspective={500}
          numbers={`${colorYield}`}
          duration={3}
        />
      </Card.Body>
    </Card>
  );
};

const styles = {
  cardBody: {
    height: '316px',
    width: '100%'
  },
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  }
};

export default memo(TotalColorYield);
